export default "__VITE_ASSET__b6960ef3__"